<style scoped lang="less">
</style>
<template>
	<div>
		<titles titlename="我的训练记录" titlecontent="这里可以看到我的训练记录" :mbx="paths"></titles>
		
	</div>
</template>

<script>
	import titles from "@/components/title/title.vue"
	
	export default{
		data(){
			return{
				// 标题
				paths: [{
					path: "/homesview/mycourse",
					name: "我的训练记录"
				}],
			}
		},
		components: {
			titles
		}
		
	}
	
	
</script>

